import { FolderType } from "shared/types/types";


export default function DossiersGrid({ dossiers, onNew, onOpen}: {dossiers:FolderType[]; onNew:()=>void; onOpen:(id: number)=>void;}){
    return(
        <div className="idk-container">
            <h1 style={{fontSize:20, fontWeight:600, marginBottom:16}}>DOSSIERS</h1>
            <div className="idk-grid">
                <button onClick={onNew} className="idk-tile">
                    <div style={{textAlign:'center', color:'#6b7280'}}>
                        <div style={{fontSize:24, lineHeight:1}}>+</div>
                        <div style={{fontSize:14, marginTop:4}}>Nouveau</div>
                    </div>
                </button>
                {dossiers.map(d => (
                    <button key={d.id} onClick={()=>onOpen(d.id)} className="idk-folder">
                        <div style={{textAlign:'center'}}>
                            <div style={{color:'#2563eb', fontWeight:600}}>{d.name}</div>
                            <div style={{marginTop:4, fontSize:12, color:'#64748b'}}>{d.visibility ? 'Public' : 'Secret'}</div>
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
}